import React from "react";
import Layout from "../components/Layout";
import SidebarLayout from "../components/Sidebar";
import { Box } from "@mui/material";

const Promos = () => {
  return (
    <Layout>
      <SidebarLayout>
        <Box pt={4}>Promos</Box>
      </SidebarLayout>
    </Layout>
  );
};

export default Promos;
